import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/app/(with-layout)/for-instructors/page.tsx");
